<template>
    <div ref="el" style="display:none" class="preview-images">
        <img v-for="img in data" :key="img[fieldNames.id]" :title="img[fieldNames.name]" :alt="img[fieldNames.name]" :src="img[fieldNames.url]"/>
    </div>
</template>

<script>
import Viewer from 'viewerjs'
import 'viewerjs/dist/viewer.css'
export default {
    name: 'v-preview',
    data () {
        return {
            index: 0,
            data: [],
            fieldNames: {
                id: 'id',
                name: 'name',
                url: 'url'
            },
            immediate: false,
            zIndex: 100000
        }
    },
    mounted () {
        this.$nextTick(() => {
            this.$refs.el.addEventListener('hidden', () => {
                if (this.immediate) {
                    this.$emit('destroy')
                    if (this.viewer) {
                        this.viewer.destroy()
                        this.viewer = null
                    }
                }
            })
            this.viewer = new Viewer(this.$refs.el, {
                initialViewIndex: this.index,
                zIndex: this.zIndex
            })
            if (this.immediate) this.show(this.index)
        })
    },
    methods: {
        show (index = 0) {
            if (this.viewer) this.viewer.view(index)
        },
        destroy () {
            if (this.viewer) {
                this.$emit('destroy')
                this.viewer.destroy()
                this.viewer = null
            }
        }
    },
    beforeDestroy () {
        this.destroy()
    }
}
</script>


// WEBPACK FOOTER //
// src/components/framework/preview/index.vue